export const getPromptActive = state => state?.prompt?.active
